import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal, SectionHeader } from "../components/site/Reveal";
import { PAINT_CORRECTION } from "../lib/content";

export default function PaintCorrection() {
  return (
    <>
      <Seo title="Paint Correction Melbourne" description="Professional single-stage and two-stage paint correction in Noble Park, Melbourne. Restore gloss, reduce swirl marks and defects." path="/paint-correction" />
      <section className="pt-32 pb-16 md:pt-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeader overline="Paint Correction" title="Restore the gloss. Reveal the finish." description="Machine polishing removes swirls, light scratches and oxidation to restore depth and clarity. Results depend on paint condition, thickness and existing defects." />
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {PAINT_CORRECTION.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.1}>
                <div data-testid={`correction-${p.id}`} className="matte p-8 h-full flex flex-col">
                  <h3 className="font-display text-2xl font-bold tracking-tight text-white">{p.name}</h3>
                  <p className="text-gray-400 text-sm font-light mt-3">{p.tagline}</p>
                  <div className="mt-4">
                    <span className="overline">From</span>
                    <p className="font-mono-tech text-3xl font-semibold text-white">${p.base}</p>
                  </div>
                  <div className="h-px bg-white/10 my-6" />
                  <ul className="space-y-3 flex-1">
                    {p.features.map((f, j) => (
                      <li key={j} className="flex items-start gap-2.5 text-sm text-gray-300 font-light">
                        <Check size={15} className="text-silver mt-0.5 shrink-0" />{f}
                      </li>
                    ))}
                  </ul>
                  {p.note && <p className="text-xs text-gray-500 italic mt-5">{p.note}</p>}
                  <Link to="/contact" state={{ estimate: { pkg: p.name } }} className="mt-7 w-full inline-block text-center bg-transparent text-white py-3.5 border border-white/20 hover:border-white hover:bg-white/5 transition-all uppercase tracking-widest text-xs font-bold">
                    Enquire
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
